/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type VerificationMethod =
  (typeof VerificationMethod)[keyof typeof VerificationMethod];

export const VerificationMethod = {
  database: "database",
  document: "document",
} as const;
